import React from 'react';

export const CurrentClientContext = React.createContext({});
